import React, { useMemo } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps } from '../types'

export const PathsEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1', '#8b5cf6', '#ec4899'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const paths = ['M10,50 Q30,20 50,50 T90,50', 'M10,30 Q30,60 50,30 T90,30', 'M10,70 Q30,40 50,70 T90,70']
  const pathWidth = 100

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        backgroundColor: effectBackgroundColor,
      }}
    >
      <svg
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
        }}
        viewBox='0 0 100 100'
        preserveAspectRatio='none'
      >
        <defs>
          <linearGradient id={`path-gradient-${index}`} x1='0%' y1='0%' x2='100%' y2='0%'>
            {effectColors.map((color, i) => (
              <stop key={i} offset={`${(i / Math.max(effectColors.length - 1, 1)) * 100}%`} stopColor={color} />
            ))}
          </linearGradient>
        </defs>

        {paths.map((path, pathIndex) => (
          <motion.path
            key={pathIndex}
            d={path}
            fill='none'
            stroke={`url(#path-gradient-${index})`}
            strokeWidth={0.5 * (pathWidth / 100)}
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{
              pathLength: [0, 1, 0],
              opacity: [0, opacityValue, 0],
            }}
            transition={{
              duration: 5 * (100 / Math.max(effectSpeed, 1)),
              repeat: Infinity,
              ease: 'easeInOut',
              delay: pathIndex * 0.5,
            }}
          />
        ))}
      </svg>
    </div>
  )
})
PathsEffect.displayName = 'PathsEffect'
